import { apiGet, apiPost, apiPut, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

export const announcementsApi = {
  listActive: (params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`/announcements/active?${searchParams.toString()}`);
  },

  listAll: (params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`/announcements?${searchParams.toString()}`);
  },

  getById: (id: string) => apiGet<{ data: Record<string, unknown> }>(`/announcements/${id}`),

  create: (body: Record<string, unknown>) => apiPost<{ data: Record<string, unknown> }>(`/announcements`, body),

  update: (id: string, body: Record<string, unknown>) => apiPut<{ data: Record<string, unknown> }>(`/announcements/${id}`, body),

  delete: (id: string) => apiDelete<{ data: Record<string, unknown> }>(`/announcements/${id}`),

  dismiss: (id: string) => apiPost<{ data: Record<string, unknown> }>(`/announcements/${id}/dismiss`),

  bulkDelete: (ids: string[]) => apiDelete<{ data: number }>(`/announcements/bulk-delete`, { data: { ids } }),

  getStats: () => apiGet<{ data: Record<string, unknown> }>(`/announcements/stats`),

  export: (format = "CSV") => apiGet<{ data: unknown }>(`/announcements/export?format=${format}`),
};